"use client";

import Session from "@lib/session";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function LogoutIfRequested() {
  // dest = 8 means logout
  const searchParams = useSearchParams();
  const dest = searchParams.get("dest");
  useEffect(() => {
    if (dest === "8") {
      Session.clearSession();
      window.location.href = `${process.env.basePath}/${window.siteId}/user/login`;
    }
  }, [dest]);

  return null;
}
